import { useState, useEffect } from "react"
import "../../../../theme/global.css"
import "../home/style.css"
import logo from "../../../../images/Logo_NN.png"

export const NotificationPreferences = () => {
	const [email, setEmail] = useState("")
	const [phoneNumber, setPhoneNumber] = useState("")
	const [emailNotifications, setEmailNotifications] = useState(false)
	const [smsNotifications, setSmsNotifications] = useState(false)
    const [termsAccepted, setTermsAccepted] = useState(false)
	const [appointmentReminders, setAppointmentReminders] = useState(false)
	const [treatmentPlanUpdates, setTreatmentPlanUpdates] = useState(false)
	const [messageNotifications, setMessageNotifications] = useState(false)
	const [isSaving, setIsSaving] = useState(false)

	// Load user preferences from API
	useEffect(() => {
		// TODO: Load notification preferences from API
		// Example:
		// dispatch(getNotificationPreferences())
	}, [])

	const handleSavePreferences = async () => {
		setIsSaving(true)
		try {
			// TODO: Save notification preferences to API
			// Example:
			// await dispatch(saveNotificationPreferences({
			//   emailNotifications,
			//   smsNotifications,
			//   appointmentReminders,
			//   carePlanUpdates,
			//   messageNotifications
			// }))
			
			// Show success message
			alert("Notification preferences saved successfully!")
		} catch (error) {
			console.error("Error saving preferences:", error)
			alert("Failed to save notification preferences. Please try again.")
		} finally {
			setIsSaving(false)
		}
	}

	return (
		<div className="infoWrapper">
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-8 col-lg-6 mx-auto">
						<div className="card shadow-sm">
							<div className="card-header bg-white border-bottom">
							<div className="text-center mb-3">
								<h4 className="mb-0">Exceptional Behavioral Health Services, LLC</h4>
							</div>
							<h4 className="mb-0">Notification Preferences</h4>
								<p className="text-muted small mb-0">Manage how you receive notifications for appointment reminders, updates to your treatment plan, and any messages you receive from your clinician.</p>
							</div>
							<div className="card-body">
							{/* Contact Information */}
							<div className="mb-4">
								<h5 className="mb-3">Contact Information</h5>
								
								<div className="mb-3">
									<label htmlFor="emailAddress" className="form-label">
										<strong>Email Address</strong>
									</label>
									<input
										type="email"
										className="form-control"
										id="emailAddress"
										placeholder="Enter your email address"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
									/>
									<div className="text-muted small mt-1">Your email for receiving notifications</div>
								</div>

								<div className="mb-3">
									<label htmlFor="phoneNumber" className="form-label">
										<strong>Phone Number</strong>
									</label>
									<input
										type="tel"
										className="form-control"
										id="phoneNumber"
										placeholder="Enter your phone number"
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
									/>
									<div className="text-muted small mt-1">Your phone number for SMS notifications</div>
								</div>
							</div>

								<div className="mb-4">
									<h5 className="mb-3">Notification Channels</h5>
									
									<div className="form-check form-switch mb-3">
										<input
											className="form-check-input"
											type="checkbox"
											id="emailNotifications"
											checked={emailNotifications}
											onChange={(e) => setEmailNotifications(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="emailNotifications">
											<strong>Email Notifications</strong>
											<div className="text-muted small">Receive notifications via email</div>
										</label>
									</div>

									<div className="form-check form-switch mb-3">
										<input
											className="form-check-input"
											type="checkbox"
											id="smsNotifications"
											checked={smsNotifications}
											onChange={(e) => setSmsNotifications(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="smsNotifications">
											<strong>SMS Notifications</strong>
											<div className="text-muted small">By checking, you are allowing to receive transactional/informational SMS communications regarding account notifications, customer care, etc, from Notenetic. Messages frequency may vary. Message and data rates may apply, reply HELP for help or STOP to opt-out.</div>
										</label>
									</div>
									<div className="form-check form-switch mb-3">
                                        <input
											className="form-check-input"
											type="checkbox"
											id="termsAndPrivacy"
											checked={termsAccepted}
											onChange={(e) => setTermsAccepted(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="termsAndPrivacy">
											<strong>Terms and Privacy Policy</strong>
											<div className="text-muted small">By checking, I accept the <a href="https://notenetic.com/terms-and-conditions" target="_blank">Terms of Service</a> and <a href="https://notenetic.com/privacy-policy" target="_blank">Privacy Policy</a>.</div>
										</label>
									</div>
								</div>

								{/* Notification Types */}
								<div className="mb-4">
									<h5 className="mb-3">Notification Types</h5>
									
									<div className="form-check form-switch mb-3">
										<input
											className="form-check-input"
											type="checkbox"
											id="appointmentReminders"
											checked={appointmentReminders}
											onChange={(e) => setAppointmentReminders(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="appointmentReminders">
											<strong>Appointment Reminders</strong>
											<div className="text-muted small">Get reminded about upcoming appointments</div>
										</label>
									</div>

									<div className="form-check form-switch mb-3">
										<input
											className="form-check-input"
											type="checkbox"
											id="treatmentPlanUpdates"
											checked={treatmentPlanUpdates}
											onChange={(e) => setTreatmentPlanUpdates(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="treatmentPlanUpdates">
											<strong>Treatment Plan Updates</strong>
											<div className="text-muted small">Receive notifications about treatment plan changes</div>
										</label>
									</div>

									<div className="form-check form-switch mb-3">
										<input
											className="form-check-input"
											type="checkbox"
											id="messageNotifications"
											checked={messageNotifications}
											onChange={(e) => setMessageNotifications(e.target.checked)}
										/>
										<label className="form-check-label" htmlFor="messageNotifications">
											<strong>New Messages</strong>
											<div className="text-muted small">Get notified when you receive new messages</div>
										</label>
									</div>
								</div>

								{/* Save Button */}
								<div className="d-grid gap-2">
									<button
										className="btn btn-primary btn-lg"
										onClick={handleSavePreferences}
										disabled={isSaving}
									>
										{isSaving ? "Saving..." : "Save Preferences"}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
